const constants = {
    ACTIONS: {
      PATCH_BANK_DETAILS_SUCCESS: "POST_WA_OTP_SUCCESS",
      PATCH_BANK_DETAILS_FAILED: "POST_WA_OTP_FAILED",
    },
  };
  export default constants;
  